import { SiteSetting } from "app/umbraco/models/settings.model";
import urlBuilder from "app/umbraco/helpers/urlBuilder";

export default (siteSettings?: SiteSetting): any => {
    let headingFile = "";
    let paragraphFile = "";
    let faviconFile = "";

    if (siteSettings?.theme?.fontHeading && siteSettings?.theme?.fontHeading.length > 0) {
        const fontHeading = siteSettings?.theme?.fontHeading?.[0]?.content;
        headingFile = fontHeading?.typekitCSS ?? "";
    }

    if (siteSettings?.theme?.fontParagraph && siteSettings?.theme?.fontParagraph.length > 0) {
        const fontParagraph = siteSettings?.theme?.fontParagraph?.[0]?.content;
        paragraphFile = fontParagraph?.typekitCSS ?? "";
    }

    if (siteSettings?.theme?.favicon) {
        faviconFile = urlBuilder(siteSettings?.theme?.favicon.umbracoFile.src).toString() ?? "";
    }

    return {
        headingFile,
        paragraphFile,
        faviconFile
    };
};